import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { PhysicalPrepaidCardDetailResponse } from '@/repositories/generated';

const responses: PhysicalPrepaidCardDetailResponse[] = [{
  basicInfo: {
    externalUserId: 'external_1',
    lastTransactionAt: '2023-04-23T00:00:00+09:00',
    paymentMethodId: '1',
    salesAt: '2023-04-23T00:00:00+09:00',
    salesShop: {
      id: '12345678',
      name: 'テスト店舗',
    },
    walletService: {
      id: '001',
      name: 'テストWS1',
    },
    walletUserId: '1',
  },
  gift: undefined,
  giftDetail: undefined,
  prepaidInfo: {
    basicPoint: 1000,
    bonusPoint: 0,
    bonusValue: 2000,
    prepaidValue: 1000,
    totalPoint: 1000,
    totalValue: 3000,
  },
  physicalPrepaidCardNumber: '0000000000000001',
  prepaidType: 'NORMAL',
  status: 'CREATE',
  totalBalance: 1000,
},
{
  basicInfo: {
    externalUserId: undefined,
    lastTransactionAt: undefined,
    paymentMethodId: '1',
    salesAt: undefined,
    salesShop: undefined,
    walletService: {
      id: '001',
      name: 'テストWS1',
    },
    walletUserId: '1',
  },
  gift: {
    giftType: 'NORMAL',
    id: 'gift002',
    name: '〇〇市給付金2',
  },
  giftDetail: {
    id: 'gift-detail001',
    name: '【赤券】（大型店・一般店で利用可能）',
  },
  prepaidInfo: {
    basicPoint: 1000,
    bonusPoint: 0,
    bonusValue: 2000,
    prepaidValue: 1000,
    totalPoint: 1000,
    totalValue: 3000,
  },
  physicalPrepaidCardNumber: '0000000000000002',
  prepaidType: 'GIFT_CERTIFICATE',
  status: 'ACTIVE',
  totalBalance: 1000,
},
{
  basicInfo: {
    externalUserId: 'external_1',
    lastTransactionAt: '2023-04-23T00:00:00+09:00',
    paymentMethodId: '1',
    salesAt: '2023-04-23T00:00:00+09:00',
    salesShop: {
      id: '12345678',
      name: 'テスト店舗',
    },
    walletService: {
      id: '001',
      name: 'テストWS1',
    },
    walletUserId: '1',
  },
  gift: {
    giftType: 'NORMAL',
    id: 'gift001',
    name: '〇〇市プレミアム付商品券1',
  },
  giftDetail: {
    id: 'gift-detail001',
    name: '【赤券】（大型店・一般店で利用可能）',
  },
  prepaidInfo: {
    basicPoint: 1000,
    bonusPoint: 2000,
    bonusValue: 2000,
    prepaidValue: 1000,
    totalPoint: 1000,
    totalValue: 3000,
  },
  physicalPrepaidCardNumber: '0000000000000003',
  prepaidType: 'GIFT_CERTIFICATE',
  status: 'DISABLED',
  totalBalance: 1000,
}];

export const physicalPrepaidCardDetail = http.get(
  createMockEndpoint('/physical_prepaid_card/:cardNumber'),
  async ({ params }) => {
    await delay(500);
    return HttpResponse.json(responses.find((response) => response.physicalPrepaidCardNumber === params.cardNumber), { status: 200 });
  },
);
